<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div v-if="archivoConBase64 !== null && archivoService.loading === false">
      <iframe class="archivo-frame" :src="'data:'+archivoConBase64.mime+';base64,'+archivoConBase64.base64"/>
    </div>
    <div v-else class="text-center">
      <h3>Cargando por favor espere...</h3>
      <b-spinner variant="primary" label="cargando"></b-spinner>
    </div>
  </div>
</template>

<script>
import {ArchivoService} from "../../apiServices/archivo/ArchivoService";

export default {
  name: "MostrarArchivoPdfOImagen",
  props: {
    archivo: {
      type: Object,
      required: true
    },
    desdeRecibo: Boolean
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    archivoService: new ArchivoService(),
    archivoConBase64: null,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  async mounted() {
    if (this.desdeRecibo){
      this.archivoConBase64 = this.archivo
    } else {
      this.archivoService.getArchivoConBase64(this.archivo.idArchivo).then(archivo => {
        this.archivoConBase64 = archivo
      })
    }

  }
}
</script>

<style scoped>
.archivo-frame {
  width: 100% !important;
  height: 600px !important;
}
</style>
